import api from '../../../../helpers/api';

export const getSelicChart = () => {
  return api.post('developer/platform/market-cycle/selic_graphic');
};

export const getRealEstateFinancingChart = () => {
  return api.post('developer/platform/market-cycle/real_estate_financing');
};

export const getReleasesRealEstateFinancingChart = (payload) => {
  return api.post(
    'developer/platform/market-cycle/releases_real_estate_financing',
    payload
  );
};

export const getMarketCycleTimeframe = () => {
  return api.get('developer/bloomberg/primary-market/list');
};

export const getReleasesVersusIPCA = (payload) => {
  return api.post(
    'developer/platform/market-cycle/releases_versus_ipca',
    payload
  );
};

export const getReleasesINCC = (payload) => {
  return api.post('developer/platform/market-cycle/releases_incc', payload);
};

export const getSecondaryINCC = (payload) => {
  return api.post('developer/platform/market-cycle/secondary_incc', payload);
};

export const getBigNumbers = (payload) => {
  return api.post('/developer/platform/market-cycle/big_numbers', payload);
};
